export enum TEST_IDS {
  stl_viewer = 'stl-viewer',
  summary_reports = 'summary-reports',
  summary_reports_detail = 'summary-reports-detail',
  annotation_pin = 'annotation-pin',
  temp_annotation_pin = 'temp-annotation-pin',
  annotation_comment = 'annotation_comment',
  model_sidebar = 'model-sidebar',
  annotation_overflow = 'annotation_overflow',
  annotation_share_button = 'annotation_share_button',
  annotation_input = 'annotation_input',
  annotation_send_button = 'annotation_send_button',
  annotation_delete_button = 'annotation_delete_button',
  back_to_thread = 'back_to_thread',
  stl_canvas = 'stl_canvas',
  primary_logo_link = 'primary_logo_link',
  not_found = 'not_found',
  annotation_comment_overflow_button = 'annotation_comment_overflow_button',
  login_header = 'login_header',
  template_detail = 'template_detail',
  login_email_field = 'login_email_field',
  settings_page = 'settings_page',
  login_password_field = 'login_password_field',
  sidebar_toggle = 'sidebar_toggle',
  fullscreen_toggle = 'fullscreen_toggle',
  sidebar_content = 'sidebar_content',
  add_reference_modal = 'add_reference_modal',
  add_reference_file_tab = 'add_reference_file_tab',
  add_reference_link_tab = 'add_reference_link_tab',
  add_reference_multifile_tab = 'add_reference_multifile_tab',
  add_reference_integrations = 'add_reference_integrations',
  edit_reference_modal = 'edit_reference_modal',
  walkthrough_card = 'walkthrough_card',
  profile_menu = 'profile_menu',
  plyable_version_history = 'plyable_version_history',
  threads_3d_version_history = 'threads_3d_version_history',
}
